module.exports = __webpack_public_path__ + "img/specials-multislider-6040--kia.8f54a1c4.jpeg";